import { Injectable } from '@angular/core';
import { CustomDataUpdatedService } from './custom-data-updated.service';
import { TranslateService } from '@ngx-translate/core';
import { ObjectType, SchemaService } from '@vendasta/auxiliary-data-components';

@Injectable({ providedIn: 'root' })
export class AccountCustomDataUpdatedService extends CustomDataUpdatedService {
  objectType: ObjectType = 'business';

  constructor(protected readonly translateService: TranslateService, protected readonly schemaService: SchemaService) {
    super(translateService, schemaService);
  }
}
